import React, { useEffect, useState } from "react";
import { Button, Dialog, EditIcon, PlusIcon, SearchInput, TrashIcon } from "evergreen-ui";
import { Card, Form, Input, message, Select, Table } from "antd";
import { MDBBox, MDBCol, MDBRow } from "mdbreact";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref, update } from "firebase/database";
import TableActionMenu from "../../../Common/TableActionMenu";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

var db = getDatabase(Firebase);
const ProvincesLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: 'Province',
			dataIndex: 'province',
			key: 'province',
			sorter: (a, b) => a.province && a.province.localeCompare(b.province),
		},
		{
			title: 'Country',
			dataIndex: 'country',
			key: 'country',
			sorter: (a, b) => a.province && a.province.localeCompare(b.province),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]
	const [provinceArray, setProvinceArray] = useState([]);
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));
	const [provinces, loading] = useListVals(ref(db, "talmidsdb/province"));
	const [dataArray, setDataArray] = useState([]);
	const [editProvince, setEditProvince] = useState(null);
	const [showEditModal, setShowEditModal] = useState(false);

	useEffect(() => {
		if (provinces) {
			var tempArray = [];
			provinces?.map((item, index) => {
				tempArray.push({
					key: index,
					province: item.provinceName,
					country: countries.find(x => (x.id === item.countryID))?.countryName,
					action: (
						<TableActionMenu
							items={[
								canUpdate && {
									key: "edit",
									label: "Edit",
									onClick: () => {
										setEditProvince(item);
										setShowEditModal(true);
									},
								},
								canDelete && {
									key: "delete",
									label: "Delete",
									danger: true,
									onClick: () => {
										if (confirm("Delete this province?")) {
											props.messageBack("province", "delete", item.id);
										}
									},
								},
							]}
						/>
					)

				})
			});

			setDataArray([...tempArray])
			setProvinceArray([...tempArray]);
		}

	}, [provinces, countries, props, canUpdate, canDelete]);

	const handleSearch = searchText => {
		const filteredEvents = dataArray.filter(({ province }) => {
			province = province.toLowerCase();
			return province.includes(searchText);
		});

		setProvinceArray(filteredEvents);
	};

	const handleEdit = (values) => {
		if (!canUpdate) {
			message.error("You do not have permission to update provinces.");
			return;
		}

		var object = {
			"provinceName": values.provinceName,
			"countryID": values.countryID,
		}

		Object.entries(object).forEach(([key, value]) => {
			if (value === undefined) {
				object[key] = "";
			}
		});

		update(ref(db, "talmidsdb/province/" + editProvince?.id), object).then(() => {
			message.success("Province Updated");
			setShowEditModal(false);
		})
			.catch((error) => {
				message.error("Unable to update : " + error);
			})
	}

	return (
		<div className="font-Nunito">
			<Dialog title="Edit Province"
				isShown={showEditModal}
				hasFooter={false}
				onCloseComplete={() => { setShowEditModal(false) }}
			>
				<MDBBox>
					<MDBRow>
						<MDBCol className="px-4">
							<Form
								layout="vertical"
								onFinish={handleEdit}
								initialValues={{
									provinceName: editProvince?.provinceName,
									countryID: editProvince?.countryID,
								}}
							>
								<Form.Item label="Enter Province name"
									name="provinceName"
									className="d-flex flex-column my-2 mt-3">
									<Input
										className="w-100"
										name="text-input-name"
										placeholder="enter province name"
									/>
								</Form.Item>
								<Form.Item label="Enter Country name"
									name="countryID"
									className="d-flex flex-column my-2 mt-3">
									<Select placeholder="select Country"
										showSearch
										optionFilterProp="children"
										filterOption={filterSelectOption}
										filterSort={sortSelectOptions}>
										{countries.map((item, index) => (
											<Select.Option value={item.id} key={index}>{item.countryName}</Select.Option>
										))}
									</Select>
								</Form.Item>
								<Button appearance="primary" htmlType="submit" className="mt-2">Edit</Button>
							</Form>
						</MDBCol>
					</MDBRow>
				</MDBBox>
			</Dialog>
			<div className="d-flex flex-row align-items-center">
				<SearchInput placeholder="Filter provinces" onChange={e => handleSearch(e.target.value)} />
				{canCreate && (
					<Button appearance="primary" className="ml-3 my-2" onClick={() => {
						props.messageBack("province", "create");
					}}>
						New Province <PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Provinces",
						exportButtons: false,
						sheetname: "Provinces",
					}), provinceArray);
				}}>
					Print
				</Button>
			</div>
			<Card className="d-flex flex-column">
				<div>
					<Table style={{ overflow: "auto" }} id={"dataTable"} dataSource={provinceArray} loading={loading}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['100', '200', '300'] }}
						columns={columns} />
				</div>
			</Card>
		</div>

	);
}

export default ProvincesLayout;
